import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { TypeImg } from 'app/shared/enum';
import { Assinatura, IAnexoConhecimento } from './file-item.type';

@Component({
    selector: 'file-item',
    templateUrl: 'file-item.component.html',
    standalone: false
})
export class FileItemComponent implements OnInit {
  @Input() file: IAnexoConhecimento;
  @Input() isEditMod: boolean = true;
   // Objeto para carregar assinaturas p7s, ex: Videos, Audios ...etc.
  @Input() assinatura: Assinatura;
  @Input() colorButton: string;

  @Output() emitDelete = new EventEmitter<number>();

  type: string = '';
  typeImg = TypeImg;
  isImg: boolean = false;

  constructor(
    private _fuseConfirmationService: FuseConfirmationService,
  ) { }

  ngOnInit (): void {
    this.extractFileType();
  }

  extractFileType (): void {
    const values = this.file.nome.split('.');
    this.type = values[values.length - 1].toUpperCase();
    if (this.type.length > 5) {
      this.type = this.type.substring(0,4) + '...'
    }
    this.isImg = this.typeImg[this.type] !== undefined;
  }

  handleTeleteFile (): void {
    const dialogRef = this._fuseConfirmationService.open({
      title: 'Confirme sua Ação',
      message: `Você deseja realmente excluir o arquivo <strong>${this.file.nome}</strong>`,
      actions: {
        confirm: {
          label: 'Excluir'
        },
        cancel: {
          label: 'Cancelar'
        }
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result === 'confirmed') {
        this.emitDelete.emit(this.file.id);
      }
    })
    // TODO: adicionar confirmação
  }

  getFileTypeFromUrl(url: string): string | null {
    // Expressão regular para capturar a extensão do arquivo
    const regex = /\/([a-zA-Z0-9_\-]+)\.([a-zA-Z0-9]+)(?:\?|$)/;
    const match = url.match(regex);
    
    if (match) {
      return match[2]; // Retorna a extensão do arquivo
    }
  
    return null; // Retorna null se não encontrar uma extensão
  }
}
